module.exports = __webpack_public_path__ + "img/presentation-bg2.ec752aa9.jpg";